import { useTranslation } from "@/i18n/client";
import { ContextModalProps } from "@mantine/modals";
import { Box } from "@mantine/core";
import { Modal } from "@/components/Modal";
import ButtonsGroup from "@/components/ButtonsGroup";
import { deleteAttachment } from "@/requests/attachment/delete";
import { FileTypeCode } from "@/constants/attachment";
import { getContractUrl } from "@/router";
import { SCREENS } from "@/router/screens";
import { useIsContractRequest } from "@/hooks/useIsContractRequest";
import { useRouter } from "next/navigation";
import { useContractState } from "@/hooks/useContractState";

export const ocrFailedModalContext = {
  modal: "ocrFailed",
  closeOnClickOutside: false,
  closeOnEscape: false,
  withCloseButton: false,
  innerProps: {},
};

export const OCRFailedModal = ({ context, id, innerProps }: ContextModalProps) => {
  const { t } = useTranslation("modals");
  const { uuid, contract, refetchContract } = useContractState();
  const isContractRequest = useIsContractRequest();
  const router = useRouter();

  const redirect = () => {
    router.replace(getContractUrl(uuid, SCREENS.CUSTOMER, isContractRequest));
  };

  const e3pAttachments = contract.attachments.filter(a => a.fileTypeCode === FileTypeCode.E3P);
  const deleteE3PAttachments = async () => {
    const attachmentsDeleted = e3pAttachments.map(a => deleteAttachment({ contractUuid: contract.uuid!, attachmentId: a.uid! }));
    await Promise.all(attachmentsDeleted);
  };

  return (
    <Box pos="relative">
      <Modal.Title>{t("ocrFailed.title")}</Modal.Title>
      <Modal.Description description={t("ocrFailed.description")} />
      <ButtonsGroup
        leftButtonText={t("ocrFailed.tryAgain")}
        rightButtonText={t("ocrFailed.fillManually")}
        onLeftButtonClick={() => {
          async function handleDelete() {
            await deleteE3PAttachments();
            await refetchContract();
            context.closeModal(id);
          }
          void handleDelete();
        }}
        onRightButtonClick={() => (redirect(), context.closeModal(id))}
        withLeftButton
      />
    </Box>
  );
};
